module.exports = __webpack_public_path__ + "static/media/logo.73fc6cf2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Candidate/InsidersList/internal/Consultation/assets/logo.svg
// module id = 1729
// module chunks = 0